var module = angular.module('octopusApp.tenants');

module.controller('TenantIndexController', function ($scope, $q, busy, octopusRepository, octopusTagSets, octopusPermissionSet, $state, $stateParams) {
    var vm = this;
    vm.isLoading = busy.create();
    vm.tenants = [];
    vm.searchText = null;
    vm.searchApplied = null;
    vm.searchTenantsByName = searchTenantsByName;
    vm.clearSearch = clearSearch;
    vm.tenantTagSetDetails = [];
    vm.toggleTagSetDisplay = toggleTagSetDisplay;
    vm.tagFilters = [];
    vm.selectedTags = [];
    vm.isFiltered = false;
    vm.addTagToFilter = addTagToFilter;
    vm.removeTagFromFilter = removeTagFromFilter;
    vm.loadMoreTenants = loadMoreTenants;
    vm.loadAllTenants = loadAllTenants;
    vm.allTenantsLoaded = false;
    var tenantFilter = {};

    function loadAllTenants() {
        vm.isLoading.promise(octopusRepository.Tenants.all().then(function (results) {
            vm.tenantsList = results;
            vm.tenants = {};

            var environmentsById = _.object(_.pluck(vm.environments, "Id"), vm.environments);
            var projectsById = _.object(_.pluck(vm.projects, "Id"), vm.projects);

            vm.tenantsList.forEach(function (tenant) {
                tenant.selectedTagSets = octopusTagSets.groupByTagSet(tenant.TenantTags);

                tenant.isMissingVariable = function () {
                    if (!vm.tenantsMissingVariables) {
                        return null;
                    }
                    return vm.tenantsMissingVariables.indexOf(tenant.Id) !== -1;
                };

                tenant.projectEnvironmentMap = buildProjectEnvironmentMap(tenant, projectsById, environmentsById);
            });
            vm.allTenantsLoaded = true;
        }));
    }

    function loadMoreTenants(skip) {
        extractSearchAndFilterParams();

        var allArgs = {};
        if (skip) {
            allArgs = _.extend(skip > 0 ? {skip: skip} : {}, tenantFilter || {});
        }
        octopusRepository.Tenants.list(allArgs).then(function (tenants) {
            vm.tenantsList = vm.tenantsList.concat(tenants.Items);
            vm.tenants = tenants;
        });
    }

    function buildProjectEnvironmentMap(tenant, projectsById, environmentsById) {
        var projectEnvironmentMap = _.chain(tenant.ProjectEnvironments).map(function (environmentIds, projectId) {
            return {
                project: projectsById[projectId],
                environments: _.chain(environmentIds).map(function (id) {
                    return environmentsById[id];
                }).filter(function (environment) {
                    return !!environment;
                }).sortBy(function (environment) {
                    return environment.SortOrder;
                }).value()
            };
        }).filter(function (x) {
            return !!x.project;
        }).sortBy(function (x) {
            return x.project.Name;
        }).value();

        return projectEnvironmentMap;
    }

    function searchTenantsByName() {
        if (!vm.searchText || vm.searchText.length === 0) {
            return;
        }

        if (vm.searchText !== vm.searchApplied) {
            $state.go($state.current, {name: vm.searchText});
            vm.isFiltered = true;
            refreshTenants();
        }
    }

    function clearSearch() {
        vm.searchText = vm.searchApplied = null;
        $state.go($state.current, {name: null});

        refreshTenants();

        vm.isFiltered = vm.selectedTags.length > 0;
    }

    function toggleTagSetDisplay(tenantTagSetDetail) {
        tenantTagSetDetail.showTags = !tenantTagSetDetail.showTags;
    }

    function addTagToFilter(tag) {
        var tagsVal = $stateParams.tags;

        if (!tagsVal) {
            tagsVal = [];
        }
        if (typeof tagsVal === "string") {
            tagsVal = [tagsVal];
        }

        var index = tagsVal.indexOf(tag.CanonicalTagName);
        if (index < 0) {
            tagsVal.push(tag.CanonicalTagName);
            $state.go($state.current, {tags:tagsVal});
        }
    }

    function removeTagFromFilter(tag) {

        var tagsVal = $stateParams.tags;
        if (!tagsVal) {
            tagsVal = [];
        }
        if (typeof tagsVal === "string") {
            tagsVal = [tagsVal];
        }

        var indexForQueryString = tagsVal.indexOf(tag.CanonicalTagName);
        if (indexForQueryString >= 0) {
            tagsVal.splice(indexForQueryString, 1);
            $state.go($state.current, {tags: tagsVal});
        }
    }

    function extractSearchAndFilterParams() {

        if ($stateParams.name) {
            vm.searchApplied = $stateParams.name;
        }
        if ($stateParams.tags) {
            var tagsVal = $stateParams.tags;
            if (typeof tagsVal === "string") {
                vm.tagFilters = [tagsVal];
            }
            else if (tagsVal.length > 0) {
                vm.tagFilters = tagsVal;
            }
        }

        _.extend(tenantFilter, { name : vm.searchApplied });
        _.extend(tenantFilter, { tags : vm.tagFilters });
    }

    function refreshTenants(skip) {

        extractSearchAndFilterParams();

        var tenantLoader = vm.allTenantsLoaded 
            ? octopusRepository.Tenants.all(tenantFilter) 
            : octopusRepository.Tenants.list(tenantFilter);

        vm.isLoading.promise(tenantLoader.then(function (results) {
            vm.tenantsList = results.Items || results;
            vm.tenants = results.Items ? results : {};

            var environmentsById = _.object(_.pluck(vm.environments, "Id"), vm.environments);
            var projectsById = _.object(_.pluck(vm.projects, "Id"), vm.projects);

            vm.tenantsList.forEach(function (tenant) {
                tenant.selectedTagSets = octopusTagSets.groupByTagSet(tenant.TenantTags);

                tenant.isMissingVariable = function () {
                    if (!vm.tenantsMissingVariables) {
                        return null;
                    }
                    return vm.tenantsMissingVariables.indexOf(tenant.Id) !== -1;
                };

                tenant.projectEnvironmentMap = buildProjectEnvironmentMap(tenant, projectsById, environmentsById);
            });
        }));
    }

    function init() {
        var projectsLoader = octopusPermissionSet.isAuthorized({
            permission: 'ProjectView',
            projectId: '*'
        }).then(function (isAuthorized) {
            return isAuthorized ? octopusRepository.Projects.all() : [];
        });

        var environmentsLoader = octopusPermissionSet.isAuthorized({
            permission: 'EnvironmentView',
            environmentId: '*'
        }).then(function (isAuthorized) {
            return isAuthorized ? octopusRepository.Environments.all() : [];
        });

        extractSearchAndFilterParams();

        var tenantLoader = octopusRepository.Tenants.list(tenantFilter);
        var tenantTagSetLoader = octopusTagSets.getAll();

        var loaders = [tenantLoader, projectsLoader, environmentsLoader, tenantTagSetLoader];
        vm.isLoading.promise($q.all(loaders).then(function (results) {
            vm.tenantsList = results[0].Items;
            vm.tenants = results[0];
            vm.projects = results[1];
            vm.environments = results[2];
            var tagSets = _.sortBy(results[3], function (tagSet) {
                return tagSet.SortOrder;
            });
            vm.tenantTagSetDetails = _.map(tagSets, function (tagSet) {
                tagSet.Tags = _.sortBy(tagSet.Tags, function (tag) {
                    return tag.SortOrder;
                });
                return {
                    showTags: true,
                    tagSet: tagSet
                };
            });

            if ((vm.tagFilters.length > 0) && vm.selectedTags.length === 0) {
                var allTags = [];
                _.map(tagSets, function (tagSet) {
                    _.map(tagSet.Tags, function (tag) {
                        allTags[tag.CanonicalTagName] = tag;
                    });
                });
                _.forEach(tenantFilter.tags, function (canonicalTagName) {
                    var tag = allTags[canonicalTagName];
                    vm.selectedTags.push(tag);
                });

                vm.isFiltered = vm.selectedTags.length > 0;
            }

            var environmentsById = _.object(_.pluck(vm.environments, "Id"), vm.environments);
            var projectsById = _.object(_.pluck(vm.projects, "Id"), vm.projects);

            vm.tenantsList.forEach(function (tenant) {
                tenant.selectedTagSets = octopusTagSets.groupByTagSet(tenant.TenantTags);

                tenant.isMissingVariable = function () {
                    if (!vm.tenantsMissingVariables) {
                        return null;
                    }
                    return vm.tenantsMissingVariables.indexOf(tenant.Id) !== -1;
                };

                tenant.projectEnvironmentMap = buildProjectEnvironmentMap(tenant, projectsById, environmentsById);
            });
        }));

        octopusRepository.Tenants.missingVariables(false).then(function (result) {
            vm.tenantsMissingVariables = _.pluck(result, 'TenantId');
        });
    }

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/controllers/tenant_index_controller.js
// module id = 4352124706658775
// module chunks = 1